import { styled } from '@mui/material';

import { ReactNode } from 'react';

import { InfoOutlineIcon } from '@app-velocity/icons';

import { Tooltip } from '../../../Tooltip';

const StyledLabelRow = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(1),
  flex: 1,
  width: '100%',
}));

const StyledInfoIcon = styled('span')(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  cursor: 'help',
  svg: {
    display: 'flex',
    width: theme.spacing(4),
    height: theme.spacing(4),
    fill: 'var(--text-text-secondary-color)',
  },
}));

export type HeadlessLabelWithTooltipProps = {
  children: ReactNode;
  tooltip: ReactNode;
  className?: string;
  inline?: boolean;
};

export const HeadlessLabelWithTooltip = ({
  children,
  tooltip,
  className,
}: HeadlessLabelWithTooltipProps) => {
  return (
    <StyledLabelRow className={className}>
      {children}
      <Tooltip title={tooltip} slotProps={{ popper: { disablePortal: true } }}>
        <StyledInfoIcon onClick={(event) => event.stopPropagation()}>
          <InfoOutlineIcon />
        </StyledInfoIcon>
      </Tooltip>
    </StyledLabelRow>
  );
};
